import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
import throttle from 'lodash/throttle';
import delay from 'lodash/delay';
import { mapGetters } from 'vuex';
import { OLAPIC_URL } from '~/const/3rd';
import { SLOW_TIMER } from '~/const/timers';
var OlapicConfig = {
  'fr-FR': {
    apikey: 'e4cf48ac99036c376bf5818f8aad3fe04a1f03cf4256b25dd64526c58ada71c6',
    mobileId: 'ac9f7b693db10ef731f9acc26dca22b2',
    desktopId: '24e1987b80c442c025853db3a98b47ba',
    lang: 'fr_FR'
  },
  'nl-BE': {
    apikey: 'a327a37b57205e24a0341ace342aef677a7c595b5407a6d8955f3bd3689daa73',
    mobileId: 'df6440958ae0fe4954ac50795af69db5',
    desktopId: 'a5b1583453842358d3f26b026d2fc87d',
    lang: 'nl_BE'
  },
  'fr-BE': {
    apikey: '0c16024a92390611327c7f2a11b61276ec04b508be31a3e04ebc195ba681c711',
    mobileId: '6c591ddc95167aab46f14b7845da2b4d',
    desktopId: '6f6b363d7b2dcef5f6f491a68e94ecb3',
    lang: 'fr_BE'
  },
  'de-DE': {
    apikey: '3cf48833d7722d7cbf2e2b9c1cdc2d84c2fb3728b60bcd8a3ae23c42d47bcc6c',
    mobileId: 'f6aa29a36789e3b4f26054fc71f483b9',
    desktopId: '91ee34dfb9c583539efcb726f8ace62e',
    lang: 'de_DE'
  },
  'es-ES': {
    apikey: '819d20f07da2468d4495a0fe2dab6e1275ee120beb942c34a5517ef21596bf9c',
    mobileId: '97b42b9441c9509533f96715e6a1cccb',
    desktopId: '8d0fc2c341fbe48f8a9946a5f25660df',
    lang: 'es_ES'
  },
  'it-IT': {
    apikey: '1090e707571449abb9d41515fce7f66c59136baaf048a75bd7257c655ce8024e',
    mobileId: '0b0a6021e1dc88d8f9db23b326b154c1',
    desktopId: '508b2079b6aab1cbd6d28e9336efeb33',
    lang: 'it_IT'
  },
  'fr-LU': {
    apikey: '7113222d43412b0e26195e166c8a2cf4bf123e495dca323375489838b64374bd',
    mobileId: 'b10da721d357ac546130e35cd12b8445',
    desktopId: 'd111a8233268d917739950cef75972c7',
    lang: 'fr_LU'
  },
  'nl-NL': {
    apikey: 'c753c6fcefd8dc0b63b7afeb585ca80daf2e473aae37e9177cd73114a550d4bc',
    mobileId: 'c9ef3f584afdaf0180b6b718429e34cd',
    desktopId: 'b120d7e14c4ba2e96e2b9dc3ccf1591d',
    lang: 'nl_NL'
  },
  'de-AT': {
    apikey: '1367312d093e39af4dcc421565f8d756e668674663ac409a2040d8ae1a7f8e1d',
    mobileId: 'f5662dc7e16d0dee6601566f9b0a9302',
    desktopId: 'd590aac7fbe5a0f7790dcf1a54e46a6e',
    lang: 'de_AT'
  },
  'pt-PT': {
    apikey: '3fb20dbfb374ff71ba314624b0bed6e9ec1f551a20fc563ae6a70df48dd9f72c',
    mobileId: '70ec46bda635fd2f66dc71d6f4c02b90',
    desktopId: '0ed91a403d0faf9fa2be5d2a2fc7e56c',
    lang: 'en_UK'
  },
  'de-CH': {
    apikey: 'c99366737aee22577564b10f7659d69f6ecf44cfe9d3cd9d37dd4f7acf4ddcd3',
    mobileId: 'a67a57ef96e55e6888c303e692cb8bbc',
    desktopId: '3698a1af062f4aa7e3392a0544ab8ad5',
    lang: 'de_CH'
  },
  'it-CH': {
    apikey: '45c1b61996619cf1a56ce5d889bf4f478f8d5fe857d909b1f48311bc0dc8558a',
    mobileId: '90cffd30d55bf682c2df5a809c156e47',
    desktopId: 'd1c85c80d8e7580b34353ed322902672',
    lang: 'it_CH'
  },
  'fr-CH': {
    apikey: 'e20997034a1676b427767001fe0cd03ab4b56d56d397fe2106d87f84207eddde',
    mobileId: 'eddeaf911236c7129ce49eded0831a61',
    desktopId: 'a1723be49affb7cd40a3afc64607d19d',
    lang: 'fr_CH'
  },
  'en-GB': {
    apikey: 'fe7e5f11755d70f4cc6aa6f274370bee21dd92c31626a1e7d256775351b51749',
    mobileId: '19fd9edf1a1ecdea52f0d3a7f1d5b243',
    desktopId: 'a503802b3099f32376514281d2836d24',
    lang: 'en_UK'
  }
};
export default {
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  mounted: function mounted() {
    this.dealWithScroll();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.throttleGoLoad);
  },
  methods: {
    dealWithScroll: function dealWithScroll() {
      window.addEventListener('scroll', this.throttleGoLoad, {
        passive: true
      });
      this.goLoad();
    },
    throttleGoLoad: throttle(function goLoad() {
      this.goLoad();
    }, 200),
    goLoad: function goLoad() {
      var _this = this;

      if ('olapic' in this.$refs && this.$refs.olapic) {
        if (window.pageYOffset < this.$refs.olapic.offsetTop - window.innerHeight - 400) {
          return;
        }
      }

      window.removeEventListener('scroll', this.throttleGoLoad);
      this.asyncScript(OLAPIC_URL).then(function () {
        delay(_this.onOlapicLoad, SLOW_TIMER);
      }).catch(function (err) {
        _this.$logger.error(err);
      });
    },
    doRender: function doRender(options) {
      window.olapic.prepareWidget(options, {
        renderNow: true,
        force: true
      });
    },
    onOlapicLoad: function onOlapicLoad() {
      var _this2 = this;

      if (window.OlapicSDK) {
        var config = OlapicConfig[this.locale.iso];
        window.OlapicSDK.conf.set('apikey', config.apikey);
        window.olapic = new window.OlapicSDK.Olapic(function (o) {
          window.olapic = o;

          _this2.doRender({
            id: _this2.isMobile() ? config.mobileId : config.desktopId,
            wrapper: 'olapic_specific_widget',
            lang: config.lang
          });
        });
      }
    }
  }
};